export default "__VITE_ASSET__CrlKenfS__"